module.exports = __webpack_public_path__ + "static/media/bell.a24d3708.png";